import moment from "moment";
import { NotificationType } from "../../cores/notifications/constants/notificationType.constant";
import {
  ConversationNotification,
  MessageNotification,
  Notification,
  SocialPostNotification,
} from "../../cores/notifications/interfaces/api/get-notifications";

/** Timestamp en ms para ordenar (más reciente primero). */
export function getNotificationTimestampMs(n: Notification): number {
  const raw = (n as Notification & { createdAt?: string }).createdAt;
  const fallback = raw ? moment(raw).valueOf() : 0;

  switch (n.type) {
    case NotificationType.MESSAGE: {
      const d = n.data as MessageNotification;
      const t = moment(d.timestamp);
      return t.isValid() ? t.valueOf() : fallback;
    }
    case NotificationType.CONVERSATION: {
      const d = n.data as ConversationNotification;
      const t = moment(d.timestamp);
      return t.isValid() ? t.valueOf() : fallback;
    }
    case NotificationType.SOCIAL_POST: {
      const d = n.data as SocialPostNotification;
      const t = moment(d.postedAt || raw);
      return t.isValid() ? t.valueOf() : fallback;
    }
    default:
      return fallback;
  }
}

export function formatNotificationRelativeTime(
  n: Notification,
  locale?: string
): string {
  const ms = getNotificationTimestampMs(n);
  if (!ms) return "—";
  const m = moment(ms);
  if (locale) m.locale(locale);
  return m.fromNow();
}

export function formatNotificationAbsoluteTime(
  n: Notification,
  locale?: string
): string {
  const ms = getNotificationTimestampMs(n);
  if (!ms) return "—";
  const m = moment(ms);
  if (locale) m.locale(locale);
  return m.format("DD MMM YYYY · HH:mm");
}
